<style scoped="scoped" lang="scss"></style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/equipment/check/template/page"
			getKey="rows" :columns="columns">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item :label="$t('shebeixiliemingcheng')">
						<el-input v-model="yt.conditions.equipmentSeriesName"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button@click="yt.get(1)" type="primary"
							plain="plain">
							{{$t('sousuo')}}
						</el-button>
						<el-button @click="yt.clear()">{{$t('chongzhi')}}
						</el-button>
						<yi_curd_expand_button></yi_curd_expand_button>
					</el-form-item>
				</el-form>
			</template>
			<!-- 左侧按钮插槽 -->
			<template #buttonsL>
				<el-button size="mini" @click="yt.showEditDialog('xinzeng',null,'w1')" type="primary">
					{{$t('xinzeng')}}
				</el-button>
			</template>
			<!-- 右侧按钮插槽 -->
			<template #buttonsR>
				<!-- <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')"  @click="yt.exportExcel()"></el-button>
            </el-button> -->
				<el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"  @click="yt.showColumnsDialog()"></el-button>
				</el-button>
			</template>
			<!-- 操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button type="text" @click="yt.showEditDialog('dianjianmingxi', scope.row,'70%')">
							{{$t('dianjianmingxi')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text" @click="yt.showEditDialog('bianji', scope.row)">{{$t('bianji')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text" class="font-color-danger"
							@click="yt.remove(scope.row,'/web/equipment/check/template/delete')">{{$t('shanchu')}}
						</el-button>
					</el-col>
				</el-row>
			</template>
			<!-- 底部插槽 -->
			<!-- <div slot="footer"></div> -->
		</yi_curd_table>

		<!-- 新增/编辑弹框 -->
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
			<!-- 新增表单 -->
			<template v-if="yt.editObj.action == 'xinzeng'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('shebeixiliemingcheng')" required>
						<yi_cross_select :component="'admin_equipment_series_list'" :max="1"
							:ids.sync="yt.editObj.equipmentSeriesId"></yi_cross_select>
					</el-form-item>
					<el-form-item :label="$t('shifouqiyong')" required="required">
						<el-select v-model="yt.editObj.enable">
							<el-option :label="$t('shi')" :value="true"></el-option>
							<el-option :label="$t('fou')" :value="false"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST','/web/equipment/check/template/create')"
						type="primary">{{$t('baocun')}}
					</el-button>
				</span>
			</template>
			<!-- 更新表单 -->
			<template v-if="yt.editObj.action == 'bianji'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<!-- 	<el-form-item :label="$t('bancibianma')" class="noborder" required="required">
						<el-input disabled v-model="yt.editObj.code">
						</el-input>
					</el-form-item> -->
					<el-form-item :label="$t('shebeixiliemingcheng')" class="noborder" required>
						<el-input disabled v-model="yt.editObj.equipmentSeriesName" disabled="true"></el-input>
					</el-form-item>
					<el-form-item :label="$t('shifouqiyong')" required="required">
						<el-select v-model="yt.editObj.enable">
							<el-option :label="$t('shi')" :value="true"></el-option>
							<el-option :label="$t('fou')" :value="false"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST','/web/equipment/check/template/update')"
						type="primary">{{$t('baocun')}}
					</el-button>
				</span>
			</template>
			<template v-if="yt.editObj.action == 'dianjianmingxi'">
				<div class="dialog-scroller">
					<inspection_item :inspectionTemplate="yt.editObj"></inspection_item>
				</div>
				<!-- <template slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button size="mini" @click="yt.req('POST','/web/equipment/model/update', null, fetchData)"
						type="primary">{{$t('baocun')}}
					</el-button>
				</template> -->
			</template>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	import inspection_item from '@@/pages/admin/data_template/equipment/inspection/inspection_item'
	export default {
		components: {
			inspection_item
		},
		name: 'admin_data_template_equipment_inspection_list',


		data() {
			return {
				list: [],
				columns: [ {
					label: 'shebeixiliemingcheng',
					prop: 'equipmentSeriesName',
					width: 130
				}, {
					label: 'shebeileixing',
					prop: 'equipmentTypeName',
					width: 130
				}, {
					label: 'shifouqiyong',
					prop: 'enable',
					type: 'bool',
					iln18: ['shi', 'fou'],
					width: 80
				}, {
					label: 'chuangjianshijian',
					prop: 'createTime',
					type: 'time',
					format: 'YYYY-MM-DD',
				}, {
					label: 'caozuo',
					type: 'slot',
					width: 260,
					fixed: 'right'
				}]
			};
		},
		created() {
			setTimeout(() => {
				this.yt.get(1);
			}, 300)

		},
		methods: {}
	};
</script>
